<template>
  <!-- Main layout: Sidebar and main content area -->
  <Sidebar />
  <div
    id="app"
    :style="{ marginLeft: sidebarWidth + 'px' }"
  >
    <Topbar />
    <!-- Centralized lightbox that can be opened from anywhere (see window.lhOpenLightbox) -->
    <Lighbox
      v-model:visible="lightboxVisible"
      :slug="lightboxSlug"
      :type="lightboxType"
      @close="onLightboxClose"
    />

    <div class="main-content" style="flex: 1 1 0; display: flex; flex-direction: column; min-height: 0;">
      <!-- Route-based content will be rendered here -->
      <router-view />
    </div>
  </div>
</template>

<script>
// Import main layout components
import Sidebar from './components/Sidebar.vue';
import Topbar from './components/Topbar.vue';
// centralized lightbox component (file is Lighbox.vue in your components folder)
import Lighbox from './components/Lighbox.vue';
import { sidebarWidth } from './utils/state.js';

export default {
  name: 'App',
  components: {
    Sidebar,
    Topbar,
    Lighbox
  },
  data() {
    return {
      posts: [],            // Stores fetched posts from the API
      loading: true,        // Loading state for API requests
      error: null,          // Error message if fetching fails
      isLoggedIn: !!localStorage.getItem('authToken'), // Auth state based on token

      // Lightbox state (centralized)
      lightboxVisible: false,
      lightboxSlug: null,
      lightboxType: 'post'
    };
  },
  computed: {
    // Dynamically calculate sidebar width for layout adjustment
    sidebarWidth() {
      return sidebarWidth.value + 8;
    }
  },
  mounted() {
    // Expose a simple global helper to open the centralized lightbox from anywhere:
    // window.lhOpenLightbox(slug, type = 'post')
    // Example: window.lhOpenLightbox('my-post-slug', 'announcement')
    // This is intentionally small and pragmatic so other components/pages can call it.
    window.lhOpenLightbox = (slug, type = 'post') => {
      this.openLightbox(slug, type);
    };

    // Optional: close lightbox on route change
    this.$router && this.$router.afterEach(() => {
      this.lightboxVisible = false;
    });
  },
  methods: {
    openLightbox(slug, type = 'post') {
      if (!slug) return;
      this.lightboxSlug = slug;
      this.lightboxType = type || 'post';
      this.lightboxVisible = true;
    },
    onLightboxClose() {
      // ensure internal state cleared when lightbox emits close
      this.lightboxVisible = false;
      this.lightboxSlug = null;
      this.lightboxType = 'post';
    }
  }
}
</script>

<style>
/* Main app styles */
#app {
  /* Remove vertical padding to prevent scroll */
  padding: 0rem 1.5rem;
  padding-bottom: 0;
  height: 100vh;
  box-sizing: border-box;	
  transition: 0.3s ease;
  min-height: 700px;
}
@media (max-width: 1100px){
  #app {
    padding: 0 0.5rem;
  }
}
</style>
